import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1.017 7.594c-.114-.18-.17-.27-.202-.408a1 1 0 0 1 0-.373c.032-.138.088-.228.202-.408C1.955 4.92 4.747 1.166 9 1.166c4.255 0 7.046 3.754 7.984 5.239.113.18.17.27.202.408a1 1 0 0 1 0 .373c-.032.138-.089.228-.202.408-.938 1.485-3.73 5.239-7.984 5.239s-7.045-3.754-7.983-5.24"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1)
  ]))]))
}
export default { render: render }